<black-video-player [resourceId]="resourceId" [autoplay]="true" class="w-full h-full block"></black-video-player>
